import { Loader } from '../utils/loader'
import { SERVICES } from '../config/constants'

class LearnLoader extends Loader {}

export const learnLoader = new LearnLoader({
  service: SERVICES.learn,
})
